<section class="breadcrumbSection">
    <div class="container mt-5 pt-3">
        <ul class="breadcrumb  text-gray-600 fs-7">
            <li class="breadcrumb-item text-gray-600">
                <a [routerLink]="'/home'" class=" breadcrumb-link text-hover-primary">
                    <i class="fa-solid fa-house iconBreadcrumb"></i>
                </a>
              </li>
              <ng-container *ngFor="let data of breadcrumb">
                <li class="breadcrumb-item text-gray-600">
                    <a [routerLink]="data.link" [queryParams]="data.params"  class="text-gray-600 breadcrumb-link text-hover-primary">{{ data.label }}</a>
                  </li>
            </ng-container>
          </ul>
    </div>
</section>